// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2q1VM","inner":"Form_inner__ELavj","range":"Form_range__3BjrC","name":"Form_name__1Dwjv","actions":"Form_actions__2XU03"};